import SocialLinks from "./SocialLinks";
import Events from "./Events";

export default function SocialMediaPresent() {
  return (
    <div className="container mx-auto px-4">
      <div className="flex flex-col lg:flex-row gap-10">
        <div className="w-full lg:w-1/2">
          <SocialLinks/>
        </div>
        <div className="w-full lg:w-1/2">
          <Events/>
        </div>
      </div>
    </div>
  )
}
